<template>
  <div style="background: #e9e9e9;">
    <div class="view">
      <ul class="w">
        <div class="v-left v-dinglan">
          <a href="wanchang" target="_blank">
            <li isview="0" class="v-li-1">完场比分</li>
          </a>
          <li isview="1" class="v-li-2 redBgc" style="cursor: not-allowed;">下日赛程</li>
          <li isview="2" class="v-li-3 redBgc">完全版</li>
          <li isview="2" class="v-li-4">NBA版</li>
          <li isview="2" class="v-li-10">CBA版</li>
          <li isview="2" class="v-li-5 redBgc">按时间</li>
          <li isview="2" class="v-li-6" style="display: none;">按赛事</li>
          <li isview="2" class="v-li-7">
            已选择赛事 ∨
            <div class="down">
              <i class="iconfont guanbi">&#xe639;</i>
              <div class="d-up">已选择赛事</div>
              <div class="d-middle">
                <ul>
                  <li></li>
                </ul>
              </div>
              <div class="d-bottom">
                <div class="b-left">
                  选中
                  <span>[5]</span>联赛
                </div>
                <div class="b-right">
                  <ul>
                    <li class="all-checked">全选</li>
                    <li class="reverse-checked">全不选</li>
                    <li class="sure-checked">确定</li>
                    <li class="cancel-checked">取消</li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li isview="2" class="v-li-8 redBgc returnChoose" @click="fullChoose()">
            完整
            <i></i>
          </li>
        </div>
      </ul>
    </div>
    <div class="calendar-ul">
      <div class="calendar-inner w">
        <div class="calendar">
          <div class="choose_calendar">
            <img src="//static.fly2a.com/static/image/calendar.png" />选择日历
            <img src="//static.fly2a.com/static/image/down.png" />
          </div>
          <div id="hdivtime"></div>
        </div>
        <div id="hmonthdivtime"></div>
      </div>
    </div>
    <div class="basketball">
      <div id="loading">
        <img src="//static.fly2a.com/static/image/f-jiazai-min.png" class="jiazai" />
      </div>
      <div class="basketball-inner w" style="min-height: 523px;">
        <div id="noListData" v-if="noListData">
          <img src="https://static.fly2a.com/gqj_tv/image/dianjing/noListData.png" alt />
        </div>
        <div class="baskClass fbClass b-fixed dont">
          <ul class="b-content fb-content" style="display:none">
            <li v-for="($value, index) in list" :data-id="$value.tournament_id"
              :style="'display: ' + filterFn($value) + ';'" :key="index">
              <div class="up">
                <div class="list_one" :data-eId="$value.league_id" style="display:none">
                  {{ $value.league_name_zh }}{{ $value.home_team_zh }}{{ $value.away_team_zh }}</div>
                <!-- 左 -->
                <div class="table-left">
                  <div class="thead th-color1" style="background-color: #a1dafa;">
                    <input type="checkbox" name="subCheckbox" :id="$value.tournament_id" />
                    <!-- 自定义checkbox样式需要 -->
                    <label :for="$value.tournament_id"></label>
                  </div>
                  <div class="tbody">
                    <span>{{ $value.start_time }}</span>
                  </div>
                </div>
                <!-- 中 -->
                <div class="table-middle">
                  <!-- 标题 -->
                  <div class="thead">
                    <div class="w-1 th-color2"
                      style="color: red;background: linear-gradient(to right, #a1dafa, transparent);">
                      <i :style="'background-color:' + $value.color"></i>
                      <span v-html="$value.league_name_zh" class="saishiName"
                        :data-lang="$value.league_name_zh + ',' + $value.league_name_zht"></span>
                      <span class="changci">{{ stateName[$value.state] }}</span>
                      <span class="countdown"></span>
                    </div>
                    <div class="w-2" v-if="$value.league_id == 8">
                      <span>上半场</span>
                      <span>下半场</span>
                    </div>
                    <div class="w-2" v-else>
                      <span>1</span>
                      <span>2</span>
                      <span>3</span>
                      <span>4</span>
                    </div>
                    <div class="w-3">
                      <span>半场</span>
                      <span>全场</span>
                      <span>分差</span>
                      <span>总分</span>
                      <!-- 问路神针 -->
                      <div class="god-anchor">
                        <div class="g-top">
                          <div class="g-top-left">
                            <div class="up">问路神针</div>
                            <p>幸运掌握在自己手中~</p>
                          </div>
                          <div class="g-top-right"></div>
                        </div>
                      </div>
                    </div>
                    <div class="w-4">欧赔</div>
                    <div class="w-5">让分盘</div>
                    <div class="w-6">大小分</div>
                  </div>
                  <!-- 内容 -->
                  <div class="tbody">
                    <div class="tbody-one">
                      <!-- 语言2 -->
                      <div class="w-1" :data-lang="$value.away_team_zh + ',' + $value.away_team_zht">
                        <span class="pointer" v-html="$value.away_team_zh" @click="togameteamslink($value.away_team_id)"
                          :style="$value.away_rank ? 'max-width:125px' : 'max-width:165px'" target="_blank"></span>
                        <i>{{ $value.away_rank ? "[" + $value.away_rank + "]" : "" }}</i>
                      </div>
                      <div class="w-2" v-if="$value.league_id == 8">
                        <span class="away_point1">-</span>
                        <span class="away_point2">-</span>
                      </div>
                      <div class="w-2" v-else>
                        <span class="away_point1">-</span>
                        <span class="away_point2">-</span>
                        <span class="away_point3">-</span>
                        <span class="away_point4">-</span>
                      </div>
                      <div class="w-3">
                        <span class="away_half">-/-</span>
                        <span class="away_all" style="color: red;font-weight: bold">-</span>
                        <!-- 总分差 -->
                        <span>
                          <em>总:</em>
                          <i class="all_fencha"></i>
                        </span>
                        <!-- 总分 -->
                        <span>
                          <em>总:</em>
                          <i class="all_zongfen"></i>
                        </span>
                      </div>
                      <!-- 初[0] 即[1] 滚[2] / 亚[0] 欧[1] 大[2] / 主[0] 盘口[1] 客[2]-->
                      <em v-html="handleOddsFn($value.a, $value.b, $value.c, 1)"></em>
                    </div>
                    <div class="tbody-two">
                      <!-- 语言3 -->
                      <div class="w-1"
                        :data-lang="$value.home_team_zh + ',' + $value.home_team_zh + ',' + $value.home_team_zht">
                        <span target="_blank" class="pointer" v-html="$value.home_team_zh"
                          :style="$value.home_rank ? 'max-width:125px' : 'max-width:165px'"
                          @click="togameteamslink($value.home_team_id)"></span>
                        <i>{{ $value.home_rank ? "[" + $value.home_rank + "]" : "" }}</i>
                        &nbsp;
                        <img src alt class="rotate-img" style="display: none" />
                      </div>
                      <div class="w-2" v-if="$value.league_id == 8">
                        <span class="home_point1">-</span>
                        <span class="home_point2">-</span>
                      </div>
                      <div class="w-2" v-else>
                        <span class="home_point1">-</span>
                        <span class="home_point2">-</span>
                        <span class="home_point3">-</span>
                        <span class="home_point4">-</span>
                      </div>
                      <div class="w-3">
                        <span class="home_half">-/-</span>
                        <span class="home_all" style="color: red;font-weight: bold">-</span>
                        <!-- 上半场分差 -->
                        <span>
                          <em>半:</em>
                          <i class="half_fencha"></i>
                        </span>
                        <!-- 上半场总分 -->
                        <span>
                          <em>半:</em>
                          <i class="half_zongfen"></i>
                        </span>
                      </div>
                      <!-- 初[0] 即[1] 滚[2] / 亚[0] 欧[1] 大[2] / 主[0] 盘口[1] 客[2]-->
                      <em v-html="handleOddsFn($value.a, $value.b, $value.c, 2)"></em>
                    </div>
                  </div>
                </div>
                <!-- 右 -->
                <div class="table-right">
                  <div class="thead">
                    <div class="twoImg">
                      <i class="collect-img iconfont icon-color-grey no-shoucang">&#xe601;</i>
                    </div>
                  </div>
                  <div class="tbody">
                    <div class="t-up">
                      <span class="analyst" v-if="!$value.recommend_id"></span>
                      <span class="analyst" :data-menId="$value.recommend_id" :data-anlId="$value.analyst_id" v-else>
                        <img :src="$value.analyst_face" />
                      </span>
                      <span target="_blank" class="pointer" @click="toshujufenxilink($value.tournament_id)">析</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="detail" v-if="$value.remark">
                <span v-html="$value.remark"></span>
              </div>
              <!-- 分析师 -->
              <div class="down">
                <div class="analyst-box" :recommend_id="$value.recommend_id"></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <lrFloat></lrFloat>
  </div>
</template>
<script>
import axios from "axios";
import lrFloat from "../components/LeftRightFloat";
import {
  bianli_saishi,
  saishiClick,
  saishiLoading,
  dinglanClick,
  returnChoose,
  eventsHideNums,
  showImg,
  langChange,
  getLangChange,
  lanComonFun,
  filterFn,
  dealItem,
} from "@/assets/js/b-filter";
import {
  eventFun,
  loadingChoose,
  collectFun,
  startLoad_collect,
} from "@/assets/js/b-basketball";
import {
  fbClass_recommend_ajax,
  postzan,
  analystEvent,
} from "@/assets/js/c-analyst.js";
var weishoucang = "&#xe601;";
var yishoucang = "&#xe694;";
export default {
  data() {
    return {
      listArr: [],
      list: [],
      shaishi: [],
      loaded: false,
      oDate: "",
      isone: 0,
      stateName: {
        0: "未开赛",
        1: "第一节",
        2: "第二节",
        3: "第三节",
        4: "第四节",
        5: "加时",
        6: "加时",
        7: "加时",
        "-1": "完场",
        "-2": "待定",
        "-3": "中断",
        "-4": "取消",
        "-5": "推迟",
        50: "中场",
      },
      noListData: 0,
      headCon: headCon(),
    };
  },
  components: {
    lrFloat,
  },
  async created() {
    this.oDate = this.$route.query.date;
    this.oDate = this.oDate ? this.oDate : this.currentDay();
    $("footer").hide();
    $("#loading").show();
    this.loaded = true;
    try {
      const res = await axios.get(COMMOND.NEW_BASE_URL + "getdate?is_web=1")
      const data = res.data
      if (data.code === 200) {
        this.oDate = (`${new Date().getUTCFullYear()}${data.data[0].date}`).replace('-', '')
      }
    } catch (e) { }
    this.request(
      "new/getbasketball_list?day=" + this.oDate + "&state=0",
      this.getListArr
    ); // 未开始比赛
    this.request(
      "new/basketball_pc_league?day=" + this.oDate + "&state=0",
      this.getShaishi
    ); // 赛事筛选
  },
  beforeMount() {
    var wx_login_t = this.$route.query.wx_login_t;
    if (wx_login_t) {
      var href = location.href;
      if (location.href.indexOf("&") == -1) {
        href = href.replace("?wx_login_t=" + wx_login_t, "");
      } else {
        href = href.replace("&wx_login_t=" + wx_login_t, "");
        href = href.replace("wx_login_t=" + wx_login_t + "&", "");
      }
      history.pushState("", "", href);
    }
  },
  mounted: function () {
    $(".haed_lanqiu").addClass("nuxt-link-exact-active");
    initCalendar("hmonthdivtime", 1, this); //日历
    initBarTime("hdivtime", 1, getNextDay, this, this.oDate); //横日历,getNextDay未来日子 getLastDay过去日子
    this.chooserili();
    eventFun(); //选中事件
  },
  methods: {
    returnChoose,
    bianli_saishi,
    saishiLoading,
    lanComonFun,
    langChange,
    eventsHideNums,
    fbClass_recommend_ajax,
    postzan,
    filterFn,
    request(url, fn) {
      url = COMMOND.NEW_BASE_URL + url;
      axios.get(url).then((res) => {
        if (fn) {
          fn(res.data);
        }
      });
    },
    handleOddsFn(a, b, c, type) {
      var odds = {};
      var div = "";
      if (c) {
        odds = JSON.parse(c);
      } else if (b) {
        odds = JSON.parse(b);
      } else if (a) {
        odds = JSON.parse(a);
      }
      if (!odds["1"]) {
        odds["1"] = ["", "", ""];
      }
      if (!odds["2"]) {
        odds["2"] = ["", "", ""];
      }
      if (!odds["3"]) {
        odds["3"] = ["", "", ""];
      }
      if (odds["1"].length == 0) {
        odds["1"] = ["", "", ""];
      }
      if (odds["2"].length == 0) {
        odds["2"] = ["", "", ""];
      }
      if (odds["3"].length == 0) {
        odds["3"] = ["", "", ""];
      }
      if (type == 1) {
        div = '<div class="w-4">';
        div += "<span>" + odds["2"][1] + "</span>";
        div += "</div>";
        div += '<div class="w-5">';
        if (odds["1"][0]) {
          if (odds["1"][0] < 0) {
            odds["1"][0] = Math.abs(odds["1"][0]);
          } else {
            odds["1"][0] = "";
          }
        }
        div += "<span>" + odds["1"][0] + "</span>";
        div += "<span>" + odds["1"][2] + "</span>";
        div += "</div>";
        div += '<div  class="w-6">';
        if (odds["3"][0]) {
          div += "<span><i>小</i>" + odds["3"][0] + "</span>";
        } else {
          div += "<span></span>";
        }
        div += "<span>" + odds["3"][2] + "</span>";
        div += "</div>";
      } else {
        div = '<div class="w-4">';
        div += "<span>" + odds["2"][0] + "</span>";
        div += "</div>";
        div += '<div class="w-5">';
        if (odds["1"][0]) {
          if (odds["1"][0] < 0) {
            odds["1"][0] = "";
          }
        }
        div += "<span>" + odds["1"][0] + "</span>";
        div += "<span>" + odds["1"][1] + "</span>";
        div += "</div>";
        div += '<div  class="w-6">';
        if (odds["3"][0]) {
          div += "<span><i>大</i>" + odds["3"][0] + "</span>";
        } else {
          div += "<span></span>";
        }
        div += "<span>" + odds["3"][1] + "</span>";
        div += "</div>";
      }
      return div;
    },
    getListArr(data) {
      this.list = data.data;
      if (this.list.length == 0) {
        this.noListData = 1;
      } else {
        this.noListData = 0;
      }
      dealItem(data.data);
      this.$nextTick(function () {
        $("#loading").hide();
        $("footer").show();
        $(".fb-content").css({ display: "block" });
        getLangChange();
        collectFun(); //收藏事件
        startLoad_collect(); //加载收藏
        loadingChoose(); //加载选中
        eventsHideNums();
        dinglanClick();
        if (!this.isone) {
          analystEvent(); //分析师推荐
          this.isone = 1;
        }
        saishiClick();
        this.loaded = false;
        $("footer").show();
      });
    },
    getShaishi(data) {
      this.shaishi = data.data;
      this.shaishiFun();
    },
    getDate() {
      var oDate = window.location.search.replace("?", "").split("&");
      var obj = {};
      for (var i = 0; i < oDate.length; i++) {
        obj[oDate[i].split("=")[0]] = oDate[i].split("=")[1];
      }
      return obj["date"] ? obj["date"] : "";
    },
    currentDay() {
      var date = new Date();
      var year = date.getFullYear(); //获取完整的年份(4位,1970-????)
      var month =
        date.getMonth() + 1 >= 10
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1); //获取当前月份(0-11,0代表1月)
      var day = date.getDate() >= 10 ? date.getDate() : "0" + date.getDate(); //获取当前日(1-31)
      return "" + year + month + day;
    },
    fullChoose() {
      returnChoose();
      var oDate = this.getDate() ? this.getDate() : this.currentDay();
      window.localStorage.removeItem("saicheng" + oDate + "-saishiItem");
      window.localStorage.removeItem("saicheng" + oDate + "-item");
    },
    togameteamslink(id) {
      window.open(
        window.location.protocol +
        "//" +
        window.location.host +
        "/lanqiu/gameteams?team_id=" +
        id
      );
    },
    toshujufenxilink(id) {
      window.open(
        window.location.protocol +
        "//" +
        window.location.host +
        "/lanqiu/shujufenxi?id=" +
        id
      );
    },
    loadAll() {
      this.loaded = false;
      this.list = this.list.concat(this.listArr.slice(30));
      this.$nextTick(function () {
        //	                console.log('v-for渲染已经完成:',new Date())
        startLoad_collect(); //加载收藏
        loadingChoose(); //加载选中
        eventsHideNums();
      });
    },
    axioslistFun(riqi) {
      //分析师列表数据
      this.loaded = true;
      this.list = [];
      this.request(
        "new/getbasketball_list?day=" + riqi + "&state=0",
        this.getListArr
      );
    },
    axiosshaishiFun(riqi) {
      //赛事数据
      this.loaded = true;
      this.request(
        "new/basketball_pc_league?day=" + riqi + "&state=0",
        this.getShaishi
      );
    },
    evn(days) {
      //选择日期
      if (!this.loaded) {
        $(".fb-content>li>.down").css("display", "none");
        if (days < this.currentDay()) {
          location.href =
            window.location.protocol +
            "//" +
            window.location.host +
            "/lanqiu/wanchang?date=" +
            days;
        } else {
          this.noListData = 0;
          history.pushState("", "", "/lanqiu/saicheng?date=" + days);
          $("#loading").show();
          //						returnChoose();
          this.axioslistFun(days);
          this.axiosshaishiFun(days);
        }
      }
    },
    search(dec) {
      // 获取搜索框的值
      if ($("#searchInput").val().length == 0) {
        return;
      }
      var kwds = $.trim($("#searchInput").val());

      var this_one = {};
      var real_name = "";
      var list = $(".list_one");
      var true_one = 0;
      if (dec) {
        active = active < 1 ? 0 : active - 1;
      }
      for (var i = 0; i < list.length; i++) {
        this_one = $(list[i]);
        //所有要找的列表值
        real_name = this_one.text().toString();
        // 匹配文字
        if (real_name.match(kwds)) {
          if (true_one == active) {
            var windows_hgt = $(window).height();
            // 获取第一个位置
            var y_len = this_one.parent().offset().top;

            $("html,body").animate(
              {
                scrollTop: y_len - windows_hgt / 2,
              },
              200
            );
            this_one.siblings().find(".tbody").addClass("flash");
            this_one.siblings().find(".thead").addClass("flash");
          } else {
            this_one.siblings().find(".tbody").removeClass("flash");
            this_one.siblings().find(".thead").removeClass("flash");
          }
          //for循环完毕计算出总个数
          true_one++;
        } else {
        }
      }

      if (!dec) {
        active = active > true_one ? 0 : active + 1;
      }
      return false;
    },
    chooserili() {
      //日历-------------------------------------------------------------
      $(".choose_calendar").on("click", function () {
        $("#hmonthdivtime").fadeToggle("fast");
      });
      $("#hmonthdivtime").mouseleave(function () {
        $("#hmonthdivtime").fadeToggle("fast");
      });
    },
    shaishiFun() {
      //选择赛事
      $(".v-li-7 .d-middle ul").html("");
      var reg1 = new RegExp("<", "g");
      var reg2 = new RegExp(">", "g");
      var reg3 = new RegExp('"', "g");
      const { hot, list } = this.shaishi;
      const tags = [];
      hot.forEach((item) => {
        item.namezh = item.gb_short;
        item.namezhid = item.gb_short
          .replace(reg1, "&lt;")
          .replace(reg2, "&gt;")
          .replace(reg3, "'"); //中文
        item.namezht = item.big_short;
        item.namezhtid = item.big_short
          .replace(reg1, "&lt;")
          .replace(reg2, "&gt;")
          .replace(reg3, "'"); //繁体
        tags.push(
          `<div class="single-checkbox"><input type="checkbox" class="eId${item.league_id}" id="${item.namezhid}" name="saishiCheck" checked><label for="${item.namezhid}">&nbsp;<span class="s-name" data-eId="${item.league_id}" data-lang="${item.namezhid},${item.namezhtid}">${item.namezh}</span><span class="s-num">[${item.num}]</span></label></div>`
        );
      });
      if (hot.length) {
        tags.unshift(
          '<li data-el="hot"><div class="m-left">热门赛事</div><div class="m-right">'
        );
        tags.push("</div></li>");
      }
      Object.keys(list).forEach((title) => {
        const nlist = list[title];
        tags.push(
          `<li data-el="${title}"><div class="m-left">${title}</div><div class="m-right">`
        );
        nlist.forEach((item) => {
          item.namezh = item.gb_short;
          item.namezhid = item.gb_short
            .replace(reg1, "&lt;")
            .replace(reg2, "&gt;")
            .replace(reg3, "'"); //中文
          item.namezht = item.big_short;
          item.namezhtid = item.big_short
            .replace(reg1, "&lt;")
            .replace(reg2, "&gt;")
            .replace(reg3, "'"); //繁体
          tags.push(
            `<div class="single-checkbox"><input type="checkbox" class="eId${item.league_id}" id="${item.namezhid}" name="saishiCheck" checked><label for="${item.namezhid}">&nbsp;<span class="s-name" data-eId="${item.league_id}" data-lang="${item.namezhid},${item.namezhtid}">${item.namezh}</span><span class="s-num">[${item.num}]</span></label></div>`
          );
        });
        tags.push("</div></li>");
      });
      $(".v-li-7 .d-middle ul").html(tags.join(""));
      setTimeout(function () {
        if ($("input:checkbox[id='CBA']").length == 0) {
          $(".v-li-10").attr("title", "暂无CBA赛事");
          $(".v-li-10").addClass("v-notcontent");
        } else {
          $(".v-li-10").attr("title", "");
          $(".v-li-10").removeClass("v-notcontent");
        }
        if ($("input:checkbox[id='NBA']").length == 0) {
          $(".v-li-4").attr("title", "暂无NBA赛事");
          $(".v-li-4").addClass("v-notcontent");
        } else {
          $(".v-li-4").attr("title", "");
          $(".v-li-4").removeClass("v-notcontent");
        }
      }, 800);
    },
  },
  metaInfo() {
    return {
      title: this.headCon["lanqiu"]["saicheng"]["title"],
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.headCon["lanqiu"]["saicheng"]["description"],
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.headCon["lanqiu"]["saicheng"]["keywords"],
        },
      ],
    };
  },
};
</script>
<style>
@import "../../assets/css/calendar-common.css";

.basketball .baskClass ul li .review {
  margin-top: -1px;
}

.basketball .baskClass ul li .up .table-middle em .w-4,
.basketball .baskClass ul li .up .table-middle em .w-5,
.basketball .baskClass ul li .up .table-middle em .w-6 {
  height: 37px;
  float: left;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-right: 1px solid #e9e9e9;
}

.basketball .baskClass ul li .up .table-middle .w-4 {
  width: 67px;
  justify-content: center !important;
}

.basketball .baskClass ul li .up .table-middle .w-5 {
  width: 96px;
  padding: 0 5px;
}

.basketball .baskClass ul li .up .table-middle .w-5 span:nth-child(1) {
  color: #e48a5b;
  width: 40px;
  text-align: center;
}

.basketball .baskClass ul li .up .table-middle .w-6 {
  width: 120px;
}

.basketball .baskClass ul li .up .table-middle .w-6 span:nth-child(1) {
  color: #e48a5b;
}

.basketball .baskClass ul li .up .table-middle .w-6 span:nth-child(1) i {
  color: #e48a5b;
}
</style>
<style scoped="scoped">
@import "../../assets/css/b-base.css";
@import "../../assets/css/b-saicheng.css";

.detail {
  background: linear-gradient(to right,
      #fbf9f9,
      #fbf9f9,
      transparent,
      transparent,
      transparent);
  margin-top: 1px;
}

.detail span {
  display: block;
  line-height: 20px;
  font-size: 12px;
  color: #989898;
  padding-left: 10px;
  position: relative;
}

.detail span::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 4px;
  background: #ff8d00;
  border-radius: 50%;
  position: absolute;
  left: 3px;
  top: 9px;
}

.view {
  height: 73px;
}

.view>ul {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.view>ul .v-left a li,
.view>ul .v-right a li {
  float: left;
  height: 38px;
  line-height: 38px;
  border: 1px solid #e24949;
  border-radius: 4px;
  color: #e24949;
  padding: 0 13px;
  cursor: pointer;
  margin-right: 10px;
}

.view>ul .v-left a li.v-active,
.view>ul .v-right a li.v-active {
  background: #e24949;
  color: #fff;
}

.view>ul .v-left>li,
.view>ul .v-right>li {
  float: left;
  height: 38px;
  line-height: 38px;
  border: 1px solid #e24949;
  border-radius: 4px;
  color: #e24949;
  padding: 0 13px;
  cursor: pointer;
  margin-right: 10px;
}

.view>ul .v-left>li.v-active,
.view>ul .v-right>li.v-active {
  background: #e24949;
  color: #fff;
}

.view>ul .v-left>li.v-notcontent,
.view>ul .v-right>li.v-notcontent {
  color: #aaa;
  border-color: #999;
  cursor: not-allowed;
}

.view>ul .v-left>li.v-notcontent.v-active,
.view>ul .v-right>li.v-notcontent.v-active {
  background: #fff;
}

.view>ul .v-left>li.view-sound,
.view>ul .v-right>li.view-sound {
  width: 85px;
  height: 38px;
  color: #fff;
  background-color: #e24949;
  position: relative;
  border: 0;
  padding: 0 8px;
}

.view>ul .v-left>li.view-sound::after,
.view>ul .v-right>li.view-sound::after {
  content: "∨";
  display: inline-block;
  background-color: #cd4646;
  position: absolute;
  top: 0;
  right: 0;
  width: 25px;
  height: 38px;
  text-align: center;
  border-radius: 0 4px 4px 0;
}

.view>ul .v-left>li.view-sound i,
.view>ul .v-right>li.view-sound i {
  vertical-align: bottom;
}

.view>ul .v-left .v-li-2,
.view>ul .v-left .v-li-9,
.view>ul .v-right .v-li-2,
.view>ul .v-right .v-li-9 {
  margin-right: 30px;
}

.view>ul .v-left .v-li-4,
.view>ul .v-right .v-li-4 {
  margin-right: 10px;
}

.view>ul .v-right {
  display: flex;
  align-items: center;
}

.view>ul .v-right>span {
  color: #a9a9a9;
  margin: 0 10px;
}

.view>ul .v-right>span a {
  color: #a9a9a9;
}

.view>ul .v-right>span .select-language {
  color: #e24949;
}

.view {
  background-color: #fff;
}

.view ul li.redBgc {
  background-color: #e24949;
  color: #fff;
  cursor: not-allowed;
}

.view ul .v-li-7 .show {
  display: block !important;
}

.view ul .v-li-7 .down {
  z-index: 100;
  display: none;
  width: 500px;
  color: #4a4a4a;
  background-color: #fff;
  border: 1px solid #f0f0f0;
  position: absolute;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  transform: translate(-13px, 15px);
}

.view ul .v-li-7 .down input,
.view ul .v-li-7 .down label {
  cursor: pointer;
}

.view ul .v-li-7 .down label:hover span {
  color: #e24949 !important;
}

.view ul .v-li-7 .down>i {
  float: right;
  line-height: 50px;
  padding-right: 20px;
  color: grey;
}

.view ul .v-li-7 .down::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 15px 10px;
  border-color: transparent transparent #f0f0f0 transparent;
  transform: translate(15px, -30px);
}

.view ul .v-li-7 .down .d-up {
  height: 50px;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.view ul .v-li-7 .down .d-middle {
  position: relative;
  height: 415px;
  padding-left: 20px;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
}

.view ul .v-li-7 .down .d-middle ul {
  position: absolute;
  padding: 10px 0;
  overflow-y: auto;
  max-height: 413px;
  min-width: 479px;
}

.view ul .v-li-7 .down .d-middle ul li {
  line-height: 13px;
}

.view ul .v-li-7 .down .d-middle ul li .m-left {
  float: left;
  width: 40px;
  font-size: 14px;
  padding-top: 12px;
  display: inline-block;
}

.view ul .v-li-7 .down .d-middle ul li .m-right {
  width: 400px;
  display: inline-block;
}

.view ul .v-li-7 .down .d-middle ul li .m-right .single-checkbox {
  padding: 10px 0;
  width: 190px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  float: left;
}

.view ul .v-li-7 .down .d-middle ul li .m-right .single-checkbox label {
  padding-top: 1px;
}

.view ul .v-li-7 .down .d-middle ul li .m-right .single-checkbox label .s-num {
  color: #b1b1b1;
}

.view ul .v-li-7 .down .d-middle ul li .m-right .single-checkbox input[type="checkbox"]+label::before {
  content: "\a0";
  /*不换行空格*/
  display: inline-block;
  width: 15px;
  height: 15px;
  vertical-align: text-bottom;
  border-radius: 1px;
  text-indent: 1px;
  line-height: 15px;
  color: #b1b1b1;
  border: 1px solid #b1b1b1;
}

.view ul .v-li-7 .down .d-middle ul li .m-right .single-checkbox input[type="checkbox"]:checked+label::before {
  content: "\2713";
  color: #db4a48;
  border: 1px solid #db4a48;
  font-size: 18px;
}

.view ul .v-li-7 .down .d-middle ul li .m-right .single-checkbox input {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}

.view ul .v-li-7 .down .d-bottom {
  height: 85px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.view ul .v-li-7 .down .d-bottom .b-left {
  display: inline-block;
}

.view ul .v-li-7 .down .d-bottom .b-right {
  display: inline-block;
}

.view ul .v-li-7 .down .d-bottom .b-right ul li {
  float: left;
  height: 30px;
  line-height: 30px;
  border: 1px solid #e24949;
  border-radius: 2px;
  color: #e24949;
  padding: 0 22px;
  margin-left: 10px;
}

.view ul .v-li-9 .show {
  display: block !important;
}

.view ul .v-li-9 .slidedown {
  z-index: 99999;
  display: none;
  width: 86px;
  color: #4a4a4a;
  position: absolute;
  padding-top: 15px;
  transform: translate(-8px, 0px);
}

.view ul .v-li-9 .slidedown>i {
  float: right;
  line-height: 50px;
  padding-right: 20px;
  color: grey;
}

.view ul .v-li-9 .slidedown::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 13px 6px;
  border-color: transparent transparent #f0f0f0 transparent;
  transform: translate(66px, -25px);
}

.view ul .v-li-9 .slidedown .d-main {
  background-color: #fff;
  border: 1px solid #f0f0f0;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
}

.view ul .v-li-9 .slidedown .d-main ul {
  text-align: center;
  padding: 10px;
}

.view ul .v-li-9 .slidedown .d-main ul li {
  height: 20px;
  line-height: 20px;
}

.view ul .v-li-9 .slidedown .d-main ul li.m-active {
  color: #fff;
  background-color: #e24949;
  border-radius: 2px;
}
</style>